import { render, staticRenderFns } from "./GetQuote.vue?vue&type=template&id=5535ca78&scoped=true"
import script from "./GetQuote.vue?vue&type=script&lang=js"
export * from "./GetQuote.vue?vue&type=script&lang=js"
import style0 from "./GetQuote.vue?vue&type=style&index=0&id=5535ca78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535ca78",
  null
  
)

export default component.exports